import { Avatar } from '@g17eco/atoms/avatar';
import { Suggestion } from '@g17eco/types/search';
import { Workgroup } from '@g17eco/types/workgroup';
import { ellipsis } from '@utils/index';
import { isOnboardingUser } from '@utils/user';

export const formatData = (suggestions: Suggestion[]) => {
  return suggestions.map((suggestion) => {
    const { status, firstName, surname } = suggestion;
    if (isOnboardingUser(status)) {
      suggestion.name = `${ellipsis(suggestion.email, 25)} (pending)`;
      return suggestion;
    }

    suggestion.name = `${firstName} ${surname}`;
    return suggestion;
  });
};

export const formatWorkgroupData = (workgroups: Workgroup[]): Suggestion[] => {
  return workgroups.map((wg) => ({
    _id: wg._id,
    name: wg.name,
    isWorkgroup: true,
    userCount: wg.users.length,
    icon: wg.icon,
    color: wg.color,
  }));
};

export const renderWorkgroupSuggestion = (suggestion: Suggestion, disabledMessage?: string) => {
  return (
    <div className={`suggestion-item ${disabledMessage ? 'disabled' : ''}`}>
      <Avatar width='30px'>
        <div className='d-flex align-items-center justify-content-center pt-2'>
          <i className={`fal fa-${suggestion.icon || 'users'}`} style={{ color: suggestion.color || '#ccc' }} />
        </div>
      </Avatar>
      <div className='name'>
        <strong>{suggestion.name}</strong>
        <div className='dont_translate'>
          <small>{suggestion.userCount || 0} user(s)</small>
        </div>
      </div>
      {disabledMessage ? <div className='message'>{disabledMessage}</div> : null}
    </div>
  );
};
